import { render, staticRenderFns } from "./ManageImage.vue?vue&type=template&id=e8116d8e"
import script from "./ManageImage.vue?vue&type=script&lang=ts"
export * from "./ManageImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports